import { thunkProgress } from 'redux-progress';
import type { Dispatch, GetState } from 'model/State';
import {
  QUOTES_POST,
  REFUND_PDF,
  QUOTE_DELETE,
  CART_INVOICE_PDF,
  ORDER_PDF,
  PO_NUMBER_UPDATE_MODAL_OPEN,
  PO_NUMBER_UPDATE_MODAL_CLOSE,
  CART_CLONE_QUOTE,
  CART_COPY_FOR_EDITING,
  VERIFICATION_HASH,
  SINGLE_ORDER,
  EDITED_CART_ORDER,
  ORDER_JSON_GET,
} from './types';
import {
  quotes,
  refundPDF,
  deleteQuote,
  cartInvoicePdf,
  orderPdf,
  cartCloneQuote,
  cartCopyForEditing,
  generateVerificationHash,
  singleOrder,
  fetchOrderCart,
  orderJson,
} from '../../api';

export const fetchQuotesPost =
  (
    maxResults: number,
    offset: number,
    orderNumberMask?: number,
    technicalContactCompanyDomainName?: string,
    integerPartOfTotalAmount?: number,
  ) =>
  (dispatch: Dispatch, getState: GetState) => {
    dispatch(
      thunkProgress(
        QUOTES_POST,
        quotes(
          getState(),
          maxResults,
          offset,
          orderNumberMask,
          technicalContactCompanyDomainName,
          integerPartOfTotalAmount,
        ),
      ),
    );
  };

export const fetchRefundPDF = (refundId: string) => (dispatch: Dispatch, getState: GetState) => {
  const hash = getState().location.query?.hash;
  dispatch(thunkProgress(REFUND_PDF, refundPDF(refundId, getState(), hash)));
};

export const fetchCartInvoicePDF = (cartId: string) => (dispatch: Dispatch, getState: GetState) => {
  const hash = getState().location.query?.hash;
  dispatch(thunkProgress(CART_INVOICE_PDF, cartInvoicePdf(cartId, getState(), hash)));
};

export const fetchCartForOrder = (cartId: string) => (dispatch: Dispatch, getState: GetState) => {
  dispatch(thunkProgress(EDITED_CART_ORDER, fetchOrderCart(cartId, getState())));
};

export const fetchOrderPDF = (orderId: number) => (dispatch: Dispatch, getState: GetState) => {
  const hash = getState().location.query?.hash;
  dispatch(thunkProgress(ORDER_PDF, orderPdf(orderId, getState(), hash)));
};

export const fetchOrderJSON = (orderId: string) => (dispatch: Dispatch, getState: GetState) => {
  const hash = getState().location.query?.hash;
  dispatch(thunkProgress(ORDER_JSON_GET, orderJson(orderId, getState(), hash)));
};

export const cloneQuote = (cartId: string) => (dispatch: Dispatch, getState: GetState) => {
  dispatch(thunkProgress(CART_CLONE_QUOTE, cartCloneQuote(cartId, getState())));
};

export const copyCartForEditing = (cartId: string) => (dispatch: Dispatch, getState: GetState) => {
  dispatch(thunkProgress(CART_COPY_FOR_EDITING, cartCopyForEditing(cartId, getState())));
};

export const deleteCurrentQuote =
  (cartId: string, displayName: string) => (dispatch: Dispatch, getState: GetState) => {
    dispatch(thunkProgress(QUOTE_DELETE, deleteQuote(cartId, displayName, getState())));
  };

export const openPONumberUpdateModal = (orderDetails: any) => (dispatch: Dispatch) => {
  dispatch({ type: PO_NUMBER_UPDATE_MODAL_OPEN, orderDetails });
};

export const closePONumberUpdateModal = (orderId: number) => (dispatch: Dispatch) => {
  dispatch({ type: PO_NUMBER_UPDATE_MODAL_CLOSE, orderId });
};

export const fetchVerificationHash =
  (orderId: number, totalIncTax: number, billingContactEmail: string) =>
  (dispatch: Dispatch, getState: GetState) => {
    dispatch(
      thunkProgress(
        VERIFICATION_HASH,
        generateVerificationHash(orderId, totalIncTax, billingContactEmail, getState()),
        { id: orderId },
      ),
    );
  };

export const fetchSingleOrder =
  (orderId: string, hash?: string) => (dispatch: Dispatch, getState: GetState) => {
    dispatch(thunkProgress(SINGLE_ORDER, singleOrder(orderId, getState(), hash), { id: orderId }));
  };
